import ToppingCard1 from "./ToppingCard1.presenter";

export default ToppingCard1;
